import * as M from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { styled } from '@mui/material/styles';

export const SelectButtonContainer = M.styled(M.Box, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  paddingBottom: theme.spacing(0.5),
  borderBottom: `1px solid ${open ? theme.palette.primary.main : theme.palette.grey[600]}`,
  borderRadius: '0px',
  minWidth: '120px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
}));

export const SelectButton = M.styled(M.Box, {
  shouldForwardProp: (prop) => prop !== 'fontSize',
})(({ theme, fontSize }) => ({
  fontFamily: 'AvenirNext',
  fontWeight: 900,
  fontSize: fontSize,
  color: theme.palette.primary.main,
  marginRight: '10px',
  marginLeft: '5px',
}));

export const ClearButton = styled(ClearIcon)(({ theme }) => ({
  padding: '0px',
  color: '#0000008a',
}));

// Styles object for use with sx prop
export const styles = {
  root: {
    display: 'flex',
    position: 'relative',
    zIndex: 1,
    minWidth: '80px',
  },
  paper: {
    marginRight: '2px',
  },
  iconButton: {
    padding: '0px',
  },
  clearButton: {
    marginLeft: '1px',
    marginRight: '1px',
  },
  menuList: {
    minWidth: '300px',
  },
  listItem: {
    padding: '0px',
    fontSize: '13px',
  },
};

export default styles;
